import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'cust_name': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'ship_cust_name': {
    title: '开票客户名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'plan_type': {
    describe: true,
    title: '计划类型',
    type: 'select',
    equation: cusname,
    dictionary: 'A0002',
    width: 180
  },
  'wlybrand': {
    describe: true,
    title: '存货分类',
    type: 'select',
    equation: all,
    dictionary: 'A0019',
    width: 180
  },
  'plan_qty': {
    title: '合同数量(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'plan_amt': {
    title: '合同金额(万元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'sal_center': {
    describe: true, // 描述 _text 添加属性
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
  },
  'zzfld00003e': {
    describe: true,
    title: '基地',
    type: 'select',
    equation: all,
    dictionary: 'base'
  },
  'region': {
    describe: true,
    title: '省份',
    type: 'select',
    equation: be,
    dictionary: 'region'
  },
  'city': {
    describe: true,
    title: '城市',
    type: 'select',
    equation: city,
    dictionary: 'city'
  },
  'sales_emp_name': {
    title: '业务员',
    type: 'input',
    equation: cusname
  },
  'datum': {
    title: '正式合同录入日期',
    type: 'date',
    equation: cusname,
    width: 140
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/contractIncludedDateReportForms.js